export const LICENSE_SYNC = 'Updates license report for this registration ID ' +
                            'with latest information from Quantum.';
export const LICENSE_SYNC_DISABLED = 'Last sync was less than an hour ago. You can synchronize only once per hour.';
